export default __webpack_public_path__ + "static/media/cp_geo_gl.6d3d4eaa.svg";